/** The app's desktop/mobile line is Tailwind's `lg` (1024px) — the sidebar
 *  most tour steps target only mounts at `lg+`. */
const DESKTOP_QUERY = '(min-width: 1024px)';

export function isDesktopViewport(): boolean {
  return typeof window !== 'undefined' && window.matchMedia(DESKTOP_QUERY).matches;
}
